import Layout from "@/components/Layout";
import { LOGO_URL, WATER_TRUCK_URL } from "@/lib/constants";
import { Shield, Star, MapPin } from "lucide-react";

export default function AboutPage() {
  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#1D4ED8]">About Cleavie's Enterprise</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-2 text-slate-900">Built in Antigua. Trusted across the island.</h1>
          <p className="mt-4 text-slate-600">
            Cleavie's Enterprise is a local family business based in Lightfoot West, St. John's. We've grown by doing one thing well:
            showing up when we say we will. Whether it's a bulk water delivery before the morning shower,
            a bin for your construction site, or a weekend rental car — our team gets it done.
          </p>
          <ul className="mt-6 space-y-3 text-sm text-slate-700">
            <li className="flex items-center gap-2"><Shield className="h-4 w-4 text-[#1D4ED8]" /> Two portals: Vehicle Rentals &amp; Leasing + Trucking &amp; Industrial Services</li>
            <li className="flex items-center gap-2"><Star className="h-4 w-4 text-[#FFCE00]" /> Transparent EC$ pricing on everything we do</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#E32636]" /> Antigua &amp; Barbuda-wide coverage</li>
          </ul>
        </div>
        <div className="relative aspect-[4/5] rounded-md overflow-hidden border border-slate-200 bg-white">
          <img src={LOGO_URL} alt="logo" className="w-full h-full object-contain p-10 bg-gradient-to-br from-red-50 via-white to-blue-50" />
        </div>
      </section>
      <section className="bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="font-heading font-black text-3xl text-slate-900">Our fleet at work.</h2>
          <div className="mt-6 relative aspect-[16/7] rounded-md overflow-hidden border border-slate-200">
            <img src={WATER_TRUCK_URL} alt="Cleavie's water truck" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </Layout>
  );
}
